'use client'

import { useTranslations } from 'next-intl'
import Link from 'next/link'

import ViverseButton from '@/components/ViverseButton'

type LittlePrinceIntroProps = {
  enableRichProfile: boolean
}

function LittlePrinceIntro({ enableRichProfile }: LittlePrinceIntroProps) {
  const t = useTranslations()

  if (!enableRichProfile) return null

  return (
    <section className="flex px-4 md:px-8 lg:px-18" data-section="profile-lp-intro">
      <div className="m-auto flex flex-col gap-6 text-center lg:max-w-[848px]">
        <h2 className="header-2 max-md:text-[28px]">{t('profile.little-prince-intro.title')}</h2>
        <p className="md:body body-1 text-white md:text-white">
          {t('profile.little-prince-intro.description')}
          <br />
          {t('profile.little-prince-intro.description-2')}
        </p>
        <div className="m-auto flex gap-2">
          <Link href="#games">
            <ViverseButton className="px-5 py-3">{t('edit-mode.button.preview')}</ViverseButton>
          </Link>
          <Link href="#embrace-the-journey">
            <ViverseButton className="px-5 py-3" variant="silent">
              {t('profile.little-prince-intro.cta')}
            </ViverseButton>
          </Link>
        </div>
      </div>
    </section>
  )
}

export default LittlePrinceIntro
